
//React Router
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url

//created components
import HeaderStep from "../../commons/headerstep/HeaderStep.jsx";

//MUI Components
import Button from '@mui/material/Button';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { shoppingStepSlice } from "../../store/shoppingStepSlice.js";
import { panierSlice } from "../../store/panierSlice.js";

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function ResaSuccess() { // component to manage the first step of shopping : choosing place and time
    const { refContrat, mail } = useParams(); //id of the selected house, in url (as string)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const lang = useSelector(getLang) //global state : language

    let mailOk = (mail === "ok"); //error code sent from step5 in navigator

    function handleClick() {
        dispatch(shoppingStepSlice.actions.goToShoppingStep(0)); //go to paiement 
        dispatch(panierSlice.actions.resetPanier());
        navigate("../");
    }
    return (
        <main>
            <HeaderStep step={6} title={"Validation de votre réservation"} custom={""} />

            <div className="resa-success">
                <div className="resa-success-top">
                    <h3>{translator("C'est tout bon!", lang, "orderOk1")}</h3>
                    <p>{translator("Votre paiement a bien été reçu et votre réservation est validée. Merci pour votre confiance :-)", lang, "orderOk2")}</p>
                    <p>{`${translator("Votre numéro de réservation :", lang, "orderOk3")} ${refContrat}`}</p>
                </div>
                <div className="resa-success-middle">
                    {
                        mailOk === true ?
                            <p>
                                {translator("Vous allez recevoir un mail avec un rappel de toutes vos informations pour cette réservation.\nCe mail fera également office de contrat de location.", lang, "orderOk4")}
                            </p>
                            :
                            <p>
                                {translator("Oups. :-( Une erreur s'est produite lors de l'envoi de votre mail de confirmation.\nNotez votre numéro de réservation ci dessus et revenez vers nous pour que nous puissions régler tout ça.\nDésolé pour ce contre temps.", lang, "orderOk5")}
                            </p>

                    }
                </div>
                <div className="resa-success-bottom">
                    <p>{translator("Voulez vous refaire une réservation ?", lang, "orderOk6")}</p>
                    <Button
                        disabled={false}
                        className="resa-success-bottom-bouton"
                        variant="contained"
                        onClick={_ => handleClick()}>
                        {translator("faire une autre réservation", lang, "orderOk7")}
                    </Button>
                    <p>Vous pouvez également revenir visiter notre site <a href="https://www.moutchicinn.com">moutchicinn.com</a></p>
                </div>

            </div>

        </main>
    )
}




export default ResaSuccess